export const PROSPECT_PRIVILEGES = {
  retail: {
    import: 'manageProspects.retail.importExport.import',
    export: 'manageProspects.retail.importExport.export',
    viewActive: 'manageProspects.retail.active.view',
    edit: 'manageProspects.retail.active.edit',
    convert: 'manageProspects.retail.active.convert',
    markLost: 'manageProspects.retail.active.markLost',
    viewLost: 'manageProspects.retail.lost.view',
    reactivate: 'manageProspects.retail.lost.reactivate'
  },
  corporate: {
    import: 'manageProspects.corporate.importExport.import',
    export: 'manageProspects.corporate.importExport.export',
    viewActive: 'manageProspects.corporate.active.view',
    edit: 'manageProspects.corporate.active.edit',
    convert: 'manageProspects.corporate.active.convert',
    markLost: 'manageProspects.corporate.active.markLost',
    viewLost: 'manageProspects.corporate.lost.view',
    reactivate: 'manageProspects.corporate.lost.reactivate'
  }
};

export const prospectAccessPrivileges = (type) => Object.values(PROSPECT_PRIVILEGES[type]);
